import React from 'react';
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';

class CogsDurationDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: false,
            selected: null,
		};
	}

	toggleSelect = () => {
		if (!this.props.loading) {
			this.setState({dropdownOpen: !this.state.dropdownOpen})
		}
	}

	onClick = (timeframe) => {
        this.setState({selected: timeframe});
		this.props.updateFilters(timeframe);
	}

	render() {
		const {dropdownOpen} = this.state;
		return (
			<Dropdown isOpen={dropdownOpen} toggle={() =>this.toggleSelect()}>
				<DropdownToggle caret>
					{this.props.loading ? "Loading" : this.state.selected ? this.state.selected : "Select a Timeframe" }
				</DropdownToggle>
				<DropdownMenu>
					<DropdownItem header>Duration</DropdownItem>
					<DropdownItem key={"weekly"} onClick={() => this.onClick("Weekly")}>
								Weekly
							</DropdownItem>
                    <DropdownItem key={"monthly"} onClick={() => this.onClick("Monthly")}>
								Monthly
							</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		);
	}
}

export default CogsDurationDropdown;
